import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.timers.js";
import "regenerator-runtime/runtime.js";
// Charts

/* import { ordersChart } from "@/components/Charts/Chart";
import Chart from "chart.js"; */

/* let chart; */
import { getBoylikegirlClubProgram, getBoylikegirlClubSap } from "../apis/services/steemActivity";
import dsteem from "../unit/DsteemUtil";
import { getAccount, extractLoginData } from "../unit/UserUtil";
import { sapDelete } from "../unit/boylikegirlcluboperUtil";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import { $t } from "../plugins/i18n";
export default {
  data: function data() {
    return {
      type: "",
      luckNumAirDropList: null,
      tableData: [],
      dialogVisible: false,
      isHavePermission: false,
      isUseKeychain: false,
      isloadEnd: false,
      acitveKey: "",
      isError: false,
      errorMessage: "",
      isLoading: false,
      program: null,
      currentPage: 1,
      pageSize: 15
    };
  },
  methods: {
    authorize: function authorize() {
      this.dialogVisible = true;
    },
    confirmAuthorize: function confirmAuthorize() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.isLoading = true;
                _context.next = 4;
                return dsteem.accountAuthorizePost(_this.acitveKey, _this.program.username);

              case 4:
                result = _context.sent;
                _this.isLoading = false;

                if (!(result.code != 0)) {
                  _context.next = 10;
                  break;
                }

                _this.isError = true;
                _this.errorMessage = result.message;
                return _context.abrupt("return");

              case 10:
                _this.isHavePermission = true;
                _this.dialogVisible = false;
                ElMessage({
                  message: _this.$t("success.authorizeSuccess"),
                  type: "success"
                });
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                _this.isError = true;
                _this.errorMessage = _context.t0.message;

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15]]);
      }))();
    },
    addPost: function addPost() {
      this.$router.push({
        path: "/sappost/" + this.$route.params.id
      });
    },
    deleteSap: function deleteSap(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ElMessageBox.confirm(_this2.$t("label.confirmDelete"), "Warning", {
                  confirmButtonText: "OK",
                  cancelButtonText: "Cancel",
                  type: "warning"
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var input, postResult;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this2.loadingInstance = ElLoading.service({
                            fullscreen: true
                          });
                          input = new Object();
                          input.author = _this2.loginData[0];
                          input.id = id;
                          _context2.next = 6;
                          return sapDelete(input);

                        case 6:
                          postResult = _context2.sent;

                          if (!(postResult.code == 0)) {
                            _context2.next = 12;
                            break;
                          }

                          _context2.next = 10;
                          return getBoylikegirlClubSap(_this2.loginData[0], _this2.currentPage - 1, _this2.pageSize);

                        case 10:
                          _this2.tableData = _context2.sent.data;

                          if (_this2.loadingInstance) {
                            _this2.loadingInstance.close();
                          }

                        case 12:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })))["catch"](function () {});

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleCurrentChange: function handleCurrentChange(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.currentPage = e;
                _context4.next = 3;
                return getBoylikegirlClubSap(_this3.loginData[0], _this3.currentPage - 1, _this3.pageSize);

              case 3:
                _this3.tableData = _context4.sent.data;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var checkAuth, arrayindex, i, len, that;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return getBoylikegirlClubProgram(_this4.$route.params.id);

            case 2:
              _this4.program = _context6.sent.data;
              _this4.loginData = extractLoginData();

              if (!_this4.loginData) {
                _context6.next = 28;
                break;
              }

              _this4.currentUserName = _this4.loginData[0];
              _this4.isUseKeychain = _this4.loginData[4] == "true";
              _context6.next = 9;
              return getAccount(_this4.currentUserName);

            case 9:
              _this4.account = _context6.sent;
              checkAuth = _this4.account.posting.account_auths;
              arrayindex = -1;

              if (!(_this4.currentUserName == _this4.program.username)) {
                _context6.next = 16;
                break;
              }

              _this4.isHavePermission = true;
              _context6.next = 25;
              break;

            case 16:
              i = 0, len = checkAuth.length;

            case 17:
              if (!(i < len)) {
                _context6.next = 25;
                break;
              }

              if (!(checkAuth[i][0] == _this4.program.username)) {
                _context6.next = 22;
                break;
              }

              arrayindex = i;
              _this4.isHavePermission = true;
              return _context6.abrupt("break", 25);

            case 22:
              i++;
              _context6.next = 17;
              break;

            case 25:
              _context6.next = 27;
              return getBoylikegirlClubSap(_this4.loginData[0], _this4.currentPage - 1, _this4.pageSize);

            case 27:
              _this4.tableData = _context6.sent.data;

            case 28:
              _this4.isloadEnd = true;
              that = _this4;
              setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return getBoylikegirlClubSap(that.loginData[0], that.currentPage - 1, that.pageSize);

                      case 2:
                        that.tableData = _context5.sent.data;

                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              })), 3000);

            case 31:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
};